import React, { Component } from 'react';

class Alerts extends Component
{
    render()
    {
        let clients = [];
        for(let i = 0; i < this.props.clients.length; i++)
        {
            let e = this.props.clients[i];
            if( e  == null)
                continue;
            clients.push(
                    <tr key={ e.id }>
                        <td><a target="_blank" href={ "/client/"+e.id }>{ e.name }</a></td>
                        <td><a target="_blank" href={ "/client/"+e.id }>{ e.phone_mobile != null ? e.phone_mobile.split(";")[0] : null }</a></td>
                        <td><a target="_blank" href={ "/client/"+e.id }>{ e.phone != null ? e.phone.split(";")[0] : null }</a></td>
                        <td><a target="_blank" href={ "/client/"+e.id }>{ e.email != null ? e.email.split(";")[0] : null }</a></td>
                        <td><a target="_blank" href={ "/client/"+e.id }>{ e.postal_code }</a></td>
                        <td><a target="_blank" href={ "/client/"+e.id }>{ e.city }</a></td>
                        <td><a target="_blank" href={ "/client/"+e.id }>{ e.nature }</a></td>
                        <td><a target="_blank" href={ "/client/"+e.id }>{ e.conseilor }</a></td>
                        <td>
                            <a className="btn btn-primary" href = {"/client/"+e.id } target="_blank" >Consulter</a>
                        </td>
                    </tr>
                
            );
        }
            
        return (
            <span>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Identité</th>
                                <th>Téléphone mobile</th>
                                <th>Téléphone fixe</th>
                                <th>Email</th>
                                <th>Code Postal</th>
                                <th>Ville</th>
                                <th>Dernière relation client</th>
                                <th>Conseiller</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            { clients }
                        </tbody>
                    </table>
                </div>
            </span>
        );
    }
}

export default Alerts;


// WEBPACK FOOTER //
// ./src/Components/Alert/Alerts.js